import { takeLatest, put, call } from "redux-saga/effects";
import {
    setAssetManagementGetFormDataSuccess, setAssetManagementGetFormDataFail,
    setAssetManagementGetByIdSuccess, setAssetManagementGetByIdFail,
    setFormAddDataFail, setFormAddDataSuccess,
    setFormUpdateDataFail, setFormUpdateDataSuccess,
    setFormGetByIdFail, setFormGetByIdSuccess,
    setFormUpdateStatusFail, setFormUpdateStatusSuccess,
} from "./Actions";
import {
    ASSET_MANAGEMENT_GET_FORM_DATA, ASSET_MANAGEMENT_GET_BY_ID,
    ASSET_MANAGEMENT_GET_FORM_DATA_API, ASSET_MANAGEMENT_GET_BY_ID_API,
    FORMLIST_ADD_DATA, FORMLIST_ADD_DATA_API,
    FORMLIST_UPDATE_DATA, FORMLIST_UPDATE_DATA_API,
    FORMLIST_GET_BY_ID, FORMLIST_GET_BY_ID_API,
    FORMLIST_UPDATE_STATUS, FORMLIST_UPDATE_STATUS_API,
} from "./Constants";
import { addErrorAlert } from "../../alert/Actions";
import { getRequest, getDetailRequest, postRequest, putRequest, patchRawRequest } from "../../../shared/components/Service";

function* getAssetManagementFormDataService() {
    try {
        const response = yield call(getRequest, ASSET_MANAGEMENT_GET_FORM_DATA_API);
        if (response.status === 200) {
            yield put(setAssetManagementGetFormDataSuccess(response.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg));
            yield put(setAssetManagementGetFormDataFail(response.response.data.msg));
        }
    } catch (error) {
        yield put(setAssetManagementGetFormDataFail(error));
    }
}

function* getAssetManagementByIdService({ form_id }) {
    try {
        const response = yield call(getDetailRequest, ASSET_MANAGEMENT_GET_BY_ID_API + form_id);
        if (response.status === 200) {
            yield put(setAssetManagementGetByIdSuccess(response.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg));
            yield put(setAssetManagementGetByIdFail(response.response.data.msg));
        }
    } catch (error) {
        yield put(setAssetManagementGetByIdFail(error));
    }
}

function* getFormByIdService({ form_id }) {
    try {
        const response = yield call(getDetailRequest, FORMLIST_GET_BY_ID_API + form_id);
        if (response.status === 200) {
            yield put(setFormGetByIdSuccess(response.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg));
            yield put(setFormGetByIdFail(response.response.data.msg));
        }
    } catch (error) {
        yield put(setFormGetByIdFail(error));
    }
}

function* addFormDataService({ data }) {
    try {
        const response = yield call(postRequest, FORMLIST_ADD_DATA_API, data);
        if (response.status === 200 || response.status === 201) {
            yield put(setFormAddDataSuccess(response.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg));
            yield put(setFormAddDataFail(response.response.data.msg));
        }
    } catch (error) {
        yield put(setFormAddDataFail(error));
    }
}

function* updateFormDataService({ form_id, data }) {
    try {
        const response = yield call(putRequest, FORMLIST_UPDATE_DATA_API + form_id, data);
        if (response.status === 200 || response.status === 201) {
            yield put(setFormUpdateDataSuccess(response.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg));
            yield put(setFormUpdateDataFail(response.response.data.msg));
        }
    } catch (error) {
        yield put(setFormUpdateDataFail(error));
    }
}

function* updateFormStatusService({ form_id, data }) {
    try {
        const response = yield call(patchRawRequest, FORMLIST_UPDATE_STATUS_API + form_id, data);
        if (response.status === 200 || response.status === 201) {
            yield put(setFormUpdateStatusSuccess(response.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg));
            yield put(setFormUpdateStatusFail(response.response.data.msg));
        }
    } catch (error) {
        yield put(setFormUpdateStatusFail(error));
    }
}
export function* watchAssetManagement() {
    yield takeLatest(ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_LOAD, getAssetManagementFormDataService);
    yield takeLatest(ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_LOAD, getAssetManagementByIdService);
    yield takeLatest(FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_LOAD, addFormDataService);
    yield takeLatest(FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_LOAD, updateFormDataService);
    yield takeLatest(FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_LOAD, getFormByIdService);
    yield takeLatest(FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_LOAD, updateFormStatusService);
}